import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import {
  PRODUCT_SKU_CONFIG_KEYS,
  CONFIG_VALIDATIONS
} from '../../../../../stubs';

export default function validateFormData(formData = {}) {
  const errors = {};

  Object.values(PRODUCT_SKU_CONFIG_KEYS).forEach(key => {
    const value = _get(formData, key);
    const validate = _get(CONFIG_VALIDATIONS, key, () => '');
    const error = validate(value);
    if (error) {
      errors[key] = error;
    }
  });

  return {
    errors,
    isValid: _isEmpty(errors)
  };
}
